import type { OverviewMenuId, SamudkoyMenuId } from "../types"

export function getMenuByPage(page: number): SamudkoyMenuId | OverviewMenuId {
  if (page >= 3 && page <= 19) return 'menu1'
  if (page >= 20 && page <= 33) return 'menu2'
  if (page >= 34 && page <= 60) return 'menu3'
  if (page >= 61 && page <= 67) return 'menu4'
  return null
}
